/*------------------------------------*\
    MODULES
\*------------------------------------*/

class BookingForm {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.startDate = self.elem.querySelector('[data-start-date]');
        self.endDate = self.elem.querySelector('[data-end-date]');
        self.bookingLink = self.elem.getAttribute('data-booking-link');
        
    }

    init() {
        let self = this;
        self.createListeners(self);
    }

    submitForm() {
        let self = this;

        var startDateValue = self.startDate.value;
        var endDateValue = self.endDate.value;

        var startDate = new Date(startDateValue);
        var endDate = new Date(endDateValue);
        
        // Format dates as 'YYYY-MM-DD' strings
        var formattedStartDate = startDate.toISOString().split('T')[0];
        var formattedEndDate = endDate.toISOString().split('T')[0];

        var lenStay = ((endDate - startDate) / (1000 * 60 * 60 * 24));
        if(lenStay < 1){
            lenStay = 3;
        }
        
        var domain = self.bookingLink;
        // Update the URL with dynamic date values
        var url = domain + '&checkIn=' + formattedStartDate + '&stayLength=' + lenStay;
        
        // Open a new tab with the constructed URL
        window.open(url, '_blank');
    }

    createListeners(self) {
        document.addEventListener('DOMContentLoaded', function () {
            // Assuming there is a form with the id 'bookingForm'
            let formElement = self;

            // Assuming there is a submit button inside the form
            let submitButton = formElement.elem.querySelector('[type="submit"]');

            // Add event listener to the form submission
            formElement.elem.addEventListener('submit', function (event) {
                event.preventDefault(); // Prevent the default form submission
                self.submitForm(); // Call the submitForm method
            });
        });
    }
}

export default BookingForm;
